module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[7]6.f678bd5.woff2";